import script from "./AppMain.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMain.vue?vue&type=script&setup=true&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=e6407570&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\e2efreight\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6407570"]])

export default __exports__